var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "yd-logo position-fixed flex-center",
      attrs: { id: "menuShowlogo" },
      on: { mouseover: _vm.onMouseOver },
    },
    [
      _c("img", {
        staticClass: "logo",
        attrs: { src: require("@/static/yd-logo-menu.png") },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }